import request from "superagent";
import { getErrorMessage } from "../../utils/errors";
import { getAuthHeader } from "../../utils/superagent";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'error' implicitly has an 'any' type.
const handleError = (error) => ({
  body: {
    error: getErrorMessage(error),
  },
});

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'userId' implicitly has an 'any' type.
const syncFirebaseUser = async (userId) => {
  const { body } = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .post(`${global.api}/agentProfile/firebase`)
    .set(await getAuthHeader())
    .send({ userId })
    .catch(handleError);

  return body;
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'reqBody' implicitly has an 'any' type.
const saveAgentPreference = async (reqBody) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .post(`${global.api}/agentProfile/preference`)
      .set(await getAuthHeader())
      .send(reqBody)
      .then(({ body }) => body)
  );
};

export { syncFirebaseUser, saveAgentPreference };
